import { cn } from '@change/ds-utils';

type Result = ModelHookResult<{
	blurClasses: string;
	avatarClasses: string;
}>;
export function useTopImpactStoryAvatar(isMobile: boolean, isCenteredOnMobile: boolean): Result {
	return {
		data: {
			blurClasses: cn(
				'absolute inset-[-10px] z-0 rounded-full opacity-0 transition-all duration-300 ease-in-out will-change-transform',
				isMobile ? [isCenteredOnMobile && 'opacity-100'] : 'group-focus-within:opacity-100 group-hover:opacity-100',
			),
			avatarClasses: cn(
				'-webkit-backface-visibility-hidden h-full w-full object-cover',
				!isMobile &&
					'transition-transform duration-300 ease-in-out group-focus-within:scale-[1.1] group-hover:scale-[1.1]',
			),
		},
	};
}
